import { combineReducers } from "redux";
import UserReducer from "./user/UserReducers";
import GeneralReducer from "./general/GeneralReducer";
import AlertReducer from "./alert/AlertReducer";
import PriceReducer from "./price/PriceReducers";
import NotificationReducer from "./notification/NotificationReducer";
import KYCReducer from "./kyc/KYCReducer";
import CoinWithdrawReducer from "./coinWithdraw/CoinWithdrawReducer";

const RootReducer = combineReducers({
  user: UserReducer,
  general: GeneralReducer,
  alert: AlertReducer,
  price: PriceReducer,
  notification: NotificationReducer,
  kyc: KYCReducer,
  coinWithdraw: CoinWithdrawReducer,
});

export default RootReducer;
